import { US_PHONE_CODE } from './const';

export function appendCodeToPhoneNumber(phoneNumber: string): string {
  if (phoneNumber.startsWith(US_PHONE_CODE)) {
    return phoneNumber;
  }

  return `${US_PHONE_CODE}${phoneNumber}`;
}

export function removeCodeFromPhoneNumber(phoneNumber?: string): string {
  return phoneNumber?.replace(US_PHONE_CODE, '') ?? '';
}
